import axios from "axios";
import API from "@/models/API";

axios.defaults.headers.Authorization = `Bearer ${localStorage.getItem(
    "accessToken"
)}`;

export default class Register {
    static getAppProviders = () => API.get(`/common/company-app-providers`);

    static getCompanySubscriptionPlans = (companyId,query) =>
        API.get(`/common/companies/${companyId}/company-subscription-plans${query}`);

    static getStoreSubscriptionPlans = (companyId,query) =>
        API.get(`/common/companies/${companyId}/subscription-plans${query}`);

    static getCountries = () => API.get(`/common/countries`);
    static getPolicyAndTerms = () => API.get(`/common/info/privacy-policy-and-terms-url`);

    static createAccount = item => API.post(`/users/registration/init`, item);

    static resendCode = item => API.post(`/users/resend-password`, item);

    static verifyMobile = item =>
        API.post(`/users/mobile/verification`, item);

    static getGiftCategories = companyId =>
        API.get(`/common/companies/${companyId}/gift-categories`);

    static getStoreCategories = () => API.get(`/common/store-categories`);

    static createStore = item => API.post(`/stores`, item);

    static createCompany = item => API.post(`/companies`, item);

    static storeSignIn = item => API.post(`/users/login`, item);

    static registrateUser = item => API.post(`/users/registration/finalize`, item);
}
